import {Injectable, OnInit} from '@angular/core';
import {BehaviorSubject, Subject, Subscription} from 'rxjs';


@Injectable()
export class ImageZoomerService {

  private _open$: Subject<any> = new Subject<any>();

  constructor(
  ) { }

  public open(imageUrl: string): void {
    this._open$.next(imageUrl);
  }

  public close(): void {
    this._open$.next(null);
  }

  get getOpen(): Subject<any> {
    return this._open$;
  }
}
